import { useRef } from "preact/hooks";
import { Icon } from "../demo-v2/chrome/icons.js";
import type { LiveCopy, WallCopy } from "./content.js";
import { useInView, useTicker } from "./motion.js";
import { PHOTOS, shortName, type WallPhoto } from "./photos.js";

const BASE_COUNT = 17;
const ARRIVALS: readonly WallPhoto[] = [...PHOTOS].reverse();

export function arrivalAt(tick: number): WallPhoto {
  return ARRIVALS[tick % ARRIVALS.length] as WallPhoto;
}

export interface LiveCardProps {
  readonly copy: LiveCopy;
  readonly wall: WallCopy;
}

export function LiveCard({ copy, wall }: LiveCardProps) {
  const root = useRef<HTMLDivElement>(null);
  const visible = useInView(root);
  const tick = useTicker(3600, visible);
  const featured = arrivalAt(tick + 2);
  const feed = [arrivalAt(tick + 1), arrivalAt(tick)];
  return (
    <div class="live" ref={root} aria-hidden="true" data-theme="dark" data-testid="live-card">
      <p class="live-label">
        <span class="live-dot" />
        {copy.label}
      </p>
      <div class="live-panel">
        <div class="live-head">
          <span class="live-chip">{copy.live}</span>
          <span class="live-event">{copy.event}</span>
          <span class="live-count">
            <strong data-testid="live-count">{BASE_COUNT + tick}</strong> {copy.count}
          </span>
        </div>
        <figure class="live-shot" key={`shot-${tick}`}>
          <img src={featured.small} alt="" width={560} height={700} />
          <figcaption>
            <span>{wall.now}</span>
            <strong>{shortName(featured.author)}</strong>
          </figcaption>
        </figure>
        <ul class="live-feed">
          {feed.map((photo, index) => (
            <li key={`row-${tick - index}`} class={index === 0 ? "is-new" : undefined}>
              <img src={photo.small} alt="" width={56} height={70} loading="lazy" />
              <span class="live-who">
                <strong>{shortName(photo.author)}</strong> {copy.sent}
              </span>
              <span class="live-when">{copy.minutes.replace("{n}", String(index + 1))}</span>
            </li>
          ))}
        </ul>
      </div>
      <p class="live-join" data-theme="light">
        <Icon name="qr" size={18} />
        {copy.join}
      </p>
    </div>
  );
}
